const traceparentHeaderName = 'traceparent';

export class JourneyTimingResponseContext {
  public captureResponseHeaders(headers: Headers): string | undefined {
    const traceparent = headers.get(traceparentHeaderName)?.trim();
    if (!traceparent) {
      return undefined;
    }

    return traceparent;
  }
}